// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-32qRdnYO clearfix","box":"box-17FD1nCJ fr"};